import dayjs from 'dayjs';

import type { LeadsRegistryDateRange } from '@app/pages/Leads/LeadsRegistryPage/model/types';

import type { Dayjs } from 'dayjs';

const MONTHS_SHORT_RU = [
  'янв',
  'фев',
  'мар',
  'апр',
  'май',
  'июн',
  'июл',
  'авг',
  'сен',
  'окт',
  'ноя',
  'дек',
];

const FULL_DATE_FORMAT = 'DD.MM.YYYY';

// Compact human-readable summary of the selected period for the trigger button.
// Examples: "Сегодня", "Вчера", "27 июн", "27–30 июн", "27 июн – 01 июл",
// "27.06.2025 – 01.07.2026" (falls back to full dates when the years differ).
export const formatLeadsPeriodLabel = ([
  start,
  end,
]: LeadsRegistryDateRange): string => {
  if (!start?.isValid() || !end?.isValid()) return 'Период';

  const today = dayjs();
  const dayMonth = (date: Dayjs) =>
    `${date.date()} ${MONTHS_SHORT_RU[date.month()]}`;

  if (start.isSame(end, 'day')) {
    if (start.isSame(today, 'day')) return 'Сегодня';
    if (start.isSame(today.subtract(1, 'day'), 'day')) return 'Вчера';

    return start.year() === today.year()
      ? dayMonth(start)
      : start.format(FULL_DATE_FORMAT);
  }

  if (start.year() !== end.year()) {
    return `${start.format(FULL_DATE_FORMAT)} – ${end.format(
      FULL_DATE_FORMAT
    )}`;
  }

  if (start.month() === end.month()) {
    return `${start.date()}–${end.date()} ${MONTHS_SHORT_RU[end.month()]}`;
  }

  return `${dayMonth(start)} – ${dayMonth(end)}`;
};
